export default __webpack_public_path__ + "static/media/2.aebf3120.jpg";